import { Message } from 'element-ui';

export const checkFormat = (file, format) => {
    const type = file.type.split('/')[1]
    let temp = []
    let isRight = false
    if (format === 'video') {
        temp = ['mp4', 'avi', 'wmv']
    } else if (format === 'picture') {
        temp = ['png', 'jpg', 'jpeg']
    } else if (format === 'audio') {
        temp = ['mp3','mpeg']
    }
    temp.find(item => {
        if (item === type) {
            isRight = true
        }
    })
    if (!isRight) {
        Message.error("上传文件只能是" + format);
    }
    return isRight;
}
function commonCompare(v1, v2) {
    if (v1 === v2) {
        return 0;
    }
    else {
        return v1 < v2 ? -1 : 1;
    }
}
export const SortLikeWin = (prop) => {
    return function (v1, v2) {
        var a = v1[prop];
        var b = v2[prop];
        var reg = /[0-9]+/g;
        var lista = a.match(reg);
        var listb = b.match(reg);
        if (!lista || !listb) {
            //return a.localeCompare(b);
            return commonCompare(a, b);
        }
        for (var i = 0, minLen = Math.min(lista.length, listb.length); i < minLen; i++) {
            //数字所在位置序号
            var indexa = a.indexOf(lista[i]);
            var indexb = b.indexOf(listb[i]);
            //数字前面的前缀
            var prefixa = a.substring(0, indexa);
            var prefixb = b.substring(0, indexb);
            //数字的string
            var stra = lista[i];
            var strb = listb[i];
            //数字的值
            var numa = parseInt(stra);
            var numb = parseInt(strb);
            //如果数字的序号不等或前缀不等，属于前缀不同的情况，直接比较
            if (indexa != indexb || prefixa != prefixb) {
                //return a.localeCompare(b);
                return commonCompare(a, b);
            }
            else {
                //数字的string全等
                if (stra === strb) {
                    //如果是最后一个数字，比较数字的后缀
                    if (i == minLen - 1) {
                        //return a.substring(indexa).localeCompare(b.substring(indexb));
                        return commonCompare(a.substring(indexa), b.substring(indexb));
                    }
                    //如果不是最后一个数字，则循环跳转到下一个数字，并去掉前面相同的部分
                    else {
                        a = a.substring(indexa + stra.length);
                        b = b.substring(indexa + stra.length);
                    }
                }
                //如果数字的string不全等，但值相等
                else if (numa == numb) {
                    //直接比较数字前缀0的个数，多的更小
                    return strb.lastIndexOf(numb + '') - stra.lastIndexOf(numa + '');
                }
                else {
                    //如果数字不等，直接比较数字大小
                    return numa - numb;
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/book/book.js